import React from "react";
import { Table } from "react-bootstrap";
import Select2V2 from "@components/FormsV2/Select2/Select2V2";
import { Opt } from "../types/PsaProject";

interface Row {
  id: string;
  name: string;
}

interface Props {
  rows: Row[];
  targets: Opt[];
  value: Record<string, string>;
  onChange: (key: string, value: string) => void;
  leftHeader: string;
  rightHeader: string;
  readOnly?: boolean;
}

const MappingTable: React.FC<Props> = ({
  rows,
  targets,
  value,
  onChange,
  leftHeader,
  rightHeader,
  readOnly,
}) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>{leftHeader}</th>
          <th>{rightHeader}</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td>{row.name}</td>
            <td>
              <Select2V2
                label=""
                options={targets}
                value={targets.find((t) => t.value === value[row.id]) ?? null}
                onChange={(o: any) => onChange(row.id, o?.value ?? "")}
                isDisabled={readOnly}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default MappingTable;
